let appendDevAPiOnDevEnv = '-prod'
let appendDevAPiOnDevEnvOldApis = '-dev' // temporary
let newApiType = 'prod'
const {
  location: { hostname },
} = window

if (
  // process.env.NODE_ENV === 'development' ||
  hostname.includes('s3-website-us-east-1.amazonaws.com') ||
  hostname.includes('.cloudfront.net')
) {
  appendDevAPiOnDevEnv = '-dev'
  appendDevAPiOnDevEnvOldApis = '-dev'
  newApiType = 'dev'
}

if (hostname.includes('dtzkcojdslre0.cloudfront.net')) {
  appendDevAPiOnDevEnv = '-development'
}

export const apiName = 'virtualClinic'

export const googleAnalyticsKEY = '-'
export const prodAppHostName = 'circadia.health'

export default {
  apiGateway: {
    REGION: 'us-east-1',
    URL: 'https://api2.circadia.io',
    URL_V2: `https://${newApiType}.circadia.link`,
    // URL_V2: `http://0.0.0.0:8090`,
    URL_EHR: newApiType === 'dev' ? 'https://ehr-dev.circadia.io:3443' : 'https://ehr.circadia.io',
  },
  trackingGateway: {
    REGION: 'us-east-1',
    DEV_URL: 'https://search-circadia-dev-td34yv2z6dtkage6xvtybeu2ea.us-east-1.es.amazonaws.com',
    URL: 'https://search-circadia-ntnplf6yvagdvpqbjh2e6ce4z4.us-east-1.es.amazonaws.com',
    SERVICE: 'es',
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_WLAItiF9J',
    APP_CLIENT_ID: '2ifse5bi9qktofuoqli0p7lol5',
    IDENTITY_POOL_ID: 'us-east-1:7a239b88-07d4-4548-8b7a-a80a2b70efb0',
  },
}

export const urls = {
  profile: {
    memberDetail: '/virtualclinic-temp/v1/memberDetail',
    memberSleepSessions: '/virtualclinic-temp/v1/memberSleepSessions',
    memberCSIHistory: '/virtualclinic-temp/v1/memberCSIHistory',
    memberSleepStages: '/sleep-session-v1/memberSleepStages',
    memberCircadianAnalysisGraphs: '/vc-computation/circadia_analysis_graphs',
    memberMetricsHistory: '/virtualclinic-temp/v1/memberMetricsHistory',
    memberDiary: '/diary/v1/view',
    memberAVGSleepMetrics: '/vc-sleep-session/v1/memberAVGSleepMetrics',
  },
  deviceAPIs: {
    linkPatient: '/clinic-inventory/v1/addPatientID',
    deviceDetail: '/clinic-inventory/v1/list', // one API used for multi purposes
    returnDevice: '/clinic-inventory/v1/returnDevice',
    dashboardDevices: '/clinic-metrics-dev/v1/patient_device',
  },
  patient: {},
}

export const apiPaths = {
  Superadmin: {
    // New APIs
    apiUserCreate: '/patient-centric-app-v2/user',

    // Clinics APIs
    apiClinicsListing: '/clinic/v1/list',
    apiClinicCreate: '/clinic/v1/create',
    apiClinicUpdate: '/patient-centric-app/clinics/{clinic_id}',
    apiUpdateUserClinics: `/portal-patient-centric${appendDevAPiOnDevEnv}/admin/user`,
    apiClinics: `/portal-patient-centric${appendDevAPiOnDevEnv}/admin/user/{user_id}/clinics`,
    apiClinicProfile: `/patient-centric-app/clinic/profile/{clinic_id}`,

    // Member APIs
    apiMemberListing: `/portal-patient-centric${appendDevAPiOnDevEnv}/admin/user`,
    apiMemberCreate: `/portal-patient-centric${appendDevAPiOnDevEnv}/admin/user`,
    apiMemberUpdate: '/sa-user/v1/update',
    apiMemberStatusUpdate: '/sa-user/v1/setStatus',
  },
  Clinic: {
    // patient centric APIs
    apiPatientListDB: `/portal-patient-centric${appendDevAPiOnDevEnv}/list`,
    apiPatientHistoryData: `/portal-patient-centric${appendDevAPiOnDevEnv}/patient/history`,
    apiPatientTiBHistoryData: `/portal-patient-centric${appendDevAPiOnDevEnv}/patient/time-in-bed-by-type`,
    apiPatientTiBHistoryCombined: `/portal-patient-centric${appendDevAPiOnDevEnv}/combined`,
    apiPatientStatus: `/portal-patient-centric${appendDevAPiOnDevEnv}/patient/status`,
    apiPatientTimeInBedData: `/portal-patient-centric${appendDevAPiOnDevEnv}/time-in-bed`,
    apiPatientRawData: `/portal-patient-centric${appendDevAPiOnDevEnv}/patient/raw`,
    apiPatientDevicesData: `/portal-patient-centric${appendDevAPiOnDevEnv}/patient/devices`,
    apiPatientDeviceTransfer: `/portal-patient-centric${appendDevAPiOnDevEnv}/patient/transfer`,
    apiPatientMinutelyAvgReport: `/portal-patient-centric${appendDevAPiOnDevEnv}/patient/minutely-average`,
    apiPatientLastResp: `/portal-patient-centric${appendDevAPiOnDevEnv}/patient/last-resp`,
    apiClinicDevices: `/portal-patient-centric${appendDevAPiOnDevEnv}/clinic/device/status`,
    apiClinicDevicesStatus: `/portal-patient-centric${appendDevAPiOnDevEnv}/clinic/device/activate`,
    apiAvailableDevicesList: `/portal-patient-centric${appendDevAPiOnDevEnv}/clinic/device/unassigned`,
    apiDischargeStatus: `/portal-patient-centric${appendDevAPiOnDevEnv}/patient/admission`,
    apiAssignDevice: `/portal-patient-centric${appendDevAPiOnDevEnv}/clinic/device/assign`,
    apiDashboardMetrics: `/portal-patient-centric${appendDevAPiOnDevEnv}/dashboard`,

    apiLastRRForAllPatients: `/portal-patient-centric${appendDevAPiOnDevEnv}/clinic/last_rr`,

    apiPatientAddUpdate: `/portal-patient-centric${appendDevAPiOnDevEnv}/patient`,

    apiDeviceDevices: '/vc-inventory-dev/v1/devices',
    apiDeviceDelete: '/vc-inventory-dev/v1/delete',
    dashboardDevices: `/clinic-metrics${appendDevAPiOnDevEnv}/v1/patient_device`,
    inventoryDevices: '/clinic-inventory/v2/list',

    // report section
    apiClinicDailyReport: `/clinical-report${appendDevAPiOnDevEnv}/daily`,
    apiClinicDailyReportClinic: `/clinical-report-dev/daily-clinic`,
    apiClinicFloor: `/portal-patient-centric${appendDevAPiOnDevEnv}/clinic/floor`,
    apiGetClinicUsers: '/vc-profile-report-dev/v1/getClinicUsers',
    apiOpenDailyReport: `/portal-patient-centric${appendDevAPiOnDevEnv}/public/pdf`,

    apiMainDeviceActivity: '/virtualclinic-temp/v1/deviceActivity',

    // new web portal
    apiClinicPatientsListing: '/vc-clinic-patient/v2/list',
    apiClinicPatientDetails: '/vc-clinic-patient/v1/list',
    apiAddClinicPatient: '/vc-clinic-patient/v1/add',
    apiUnassignDevice: '/vc-clinic-patient/v1/unlinkDevice',
    apiPatientUpdate: '/vc-clinic-patient/v1/update',
    apiPatientDischarge: '/vc-clinic-patient/v1/discharge',
    apiPatientDelete: '/vc-clinic-patient/v1/delete',
    apiPatientReAdmit: '/vc-clinic-patient/v1/reAdmit',
    apiPatientIds: '/vc-clinic-patient/v1/getPatientIds',

    // new billing section
    apiBllingList: `/portal-patient-centric${appendDevAPiOnDevEnv}/billing/clinic/monthly`,
    apiBllingPatientMonthly: `/portal-patient-centric${appendDevAPiOnDevEnv}/billing/patient/monthly`,

    // SMS subscription
    apiSMSSubscriptionList: '/vc-ec/v1/list',
    apiSMSSubscriptionAdd: '/vc-ec/v1/add',
    apiSMSSubscriptionDisable: '/vc-ec/v1/disable',

    // Profile
    apiClinicNotesCreate: '/notes/v1/create',
    apiClinicNotesUpdate: '/notes/v1/update',
    apiClinicNotesList: '/notes/v1/list',
    apiMinutelyAvgReport: '/clinic-resp-dev/v1/minutelyAvgReport',
    apiLastResp: '/clinic-resp-dev/v1/lastResp',
    apiBoxPlotData: '/clinic-resp-dev/v1/boxPlotData',
    apiDeviceRawRRData: '/vc-profile-report/v1/raw_resp',
    apiTimeInBedData: '/clinic-metrics/v1/time_in_bed',
    apidailyPatientReport: `/clinical-report${appendDevAPiOnDevEnv}/patient-data`,

    // clinics
    apiMyClinic: `/portal-patient-centric${appendDevAPiOnDevEnv}/my-clinic`, // '/clinic-dev/v2/myClinic',

    apiEligibilityLogs: `/elg${appendDevAPiOnDevEnvOldApis}/v1/list`,
    apiReportDevices: '/clinic-inventory/v1/all',
    apiReportPatients: '/vc-clinic-patient/v1/all',
    // Device
    apiUpdateDeviceInfo: '/clinic-inventory/v1/updateDevice',
    apiDeviceRScore: '/md-resp-dev/v1/rscore', // temporary api
    apiEmailReport: '/vc-profile-report/v1/sendEmail',

    // notifications
    apiNotificationList: '/vc-notification/v1/list',
    apiNotificationSeen: '/vc-notification/v1/seen',
    apiNotificationSeenAll: '/vc-notification/v1/seen_all',

    // statuses
    apiStatusesLogs: `/portal-patient-centric${appendDevAPiOnDevEnv}/statuses/logs`,

    // change notes of resident
    apiStoreChangeNote: `/portal-patient-centric${appendDevAPiOnDevEnv}/statuses/status`,
    apiGetAllStoredNotesOfPatient: `/portal-patient-centric${appendDevAPiOnDevEnv}/statuses/status`,

    // password verifycation
    apiVerifyPassword: `/portal-patient-centric${appendDevAPiOnDevEnv}/statuses/password`,
    tracking: `/tracking/_doc`,
  },
}

export const trackingReportsTypes = {
  dashboard: {
    time_spent: 'time_spent',
    clicked_card: 'clicked_card',
    change_sorting: 'change_sorting',
    filtering: 'filtering',
  },
  profile: {
    live: 'live',
    hourly: 'hourly',
    daily: 'daily',
    notes: 'notes',
    info: 'info',
    setting: 'setting',
    status_changed: 'status_changed',
  },
  resident_dir: {
    discharge_residents: 'discharge_residents',
    delete_residents: 'delete_residents',
    new_resident: 'new_resident',
    clicked: 'clicked',
  },
  room_dir: {
    report_generated: 'report_generated',
    generated: 'generated',
    downloaded: 'downloaded',
    send_email: 'send_email',
  },
  billing: {
    view: 'view',
    generated: 'generated',
    downloaded: 'downloaded',
    clicked: 'clicked',
  },
}

export const newAPIPaths = {
  createClinic: '/patient-centric-app-v2/admin/v2/clinics',
  getAllClinic: '/patient-centric-app-v2/admin/clinics',
  updateOneClinic: '/patient-centric-app-v2/admin/v4/clinics/{clinic_id}',
  getOneClinic: '/patient-centric-app-v2/admin/clinics/{clinic_id}',
  getOneClinicFloor: '/patient-centric-app-v2/admin/clinics/{clinic_id}/floors',
  getAllUser: '/patient-centric-app-v2/admin/users',
  getAllUserV2: '/patient-centric-app-v2/admin/v2/users',
  getOneUser: '/patient-centric-app-v2/admin/v2/users/{user_id}',
  getOneUserLoginHistory: '/patient-centric-app-v2/admin/users/{user_id}/login/history',
  getOneUserClinics: '/patient-centric-app-v2/admin/users/{user_id}/clinics',
  updateUserClinics: '/patient-centric-app-v2/admin/users/{user_id}/clinics',
  assignUsersClinics: '/patient-centric-app-v2/admin/clinics/assign/users',
  updateUserStatus: '/patient-centric-app-v2/admin/users/{user_id}/status',
  createUser: '/patient-centric-app-v2/admin/v2/users',
  updateUser: '/patient-centric-app-v2/admin/v3/users/{user_id}',
  deleteUser: '/patient-centric-app-v2/admin/users/{user_id}',
  resetPasswordAPI: '/patient-centric-app-v2/admin/users/send_set_password_email/{user_id}',
  getAllDevice: '/patient-centric-app-v2/admin/devices',
  getAllDeviceWithoutPagination: '/patient-centric-app-v2/admin/v2/devices',
  getDeviceRecord: '/patient-centric-app-v2/admin/devices/device_records',
  updateDeviceRecordStatus: '/patient-centric-app-v2/admin/devices/update_device_status',
  getDeviceInventory: '/patient-centric-app-v2/admin/devices/inventory_in_records',
  updateDeviceInventoryStatus: '/patient-centric-app-v2/admin/devices/update_inventory_in_status',
  getDeviceConnection: '/patient-centric-app-v2/admin/devices/device_connection_records',
  getDevicesMetrics: '/patient-centric-app-v2/admin/devices/metrics',
  createSingleDevice: '/patient-centric-app-v2/admin/v2/devices',
  createMultipleDevice: '/patient-centric-app-v2/admin/devices/{clinic_id}/raw',
  modifyReplaceDevices: '/patient-centric-app-v2/admin/devices/{clinic_id}/replace-devices/csv',
  modifyReplaceDevicesRaw:
    '/patient-centric-app-v2/admin/devices/{clinic_id}/replace-devices/v3/raw',
  removeDevice: '/patient-centric-app-v2/admin/devices/{clinic_id}/{device_id}/remove-device',

  // Medical Group
  getMedicalGroupListing: '/patient-centric-app-v2/admin/medical_groups',
  getMedicalGroupDetails: '/patient-centric-app-v2/admin/medical_groups/{medical_group_id}',
  addMedicalGroup: '/patient-centric-app-v2/admin/medical_groups',
  updateMedicalGroup: '/patient-centric-app-v2/admin/medical_groups/{medical_group_id}',
  assignFacilitiesToMedicalGroup:
    '/patient-centric-app-v2/admin/medical_groups/{medical_group_id}/clinics',

  // PCC Integration
  apiImportPCCResidents: '/api/v2/clinics/import_resident',
}
